import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppInfoService } from 'core/app-info/app-info.service';
import { NotificationType } from 'core/notification/notification-config.class';
import { NotificationService } from 'core/notification/notification.service';
import { BaseResponse } from 'src/app/modules/shared/entities/base-response';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ShortContact } from '../entities/short-contact.class';
import { PrintExportQuoteComponent } from '../quote/print-export-quote/print-export-quote.component';
import { QuoteToolsService } from '../services/quote-tools.service';

@Component({
  selector: 'app-order-completed',
  templateUrl: './order-completed.component.html',
  styleUrls: ['./order-completed.component.scss'],
  standalone: false
})
export class OrderCompletedComponent implements OnInit, OnDestroy {
  @Input() orderConfirmationNumber: string;
  @Input() quoteRevisionId: string;
  @Input() ensEmails: string[] = [];
  @Input() contacts: ShortContact[] = [];

  appStrings: AppLocalization = this.appInfoService.appStrings;
  isOnline = true;
  isMobile: boolean;
  private subs = new Subscription();

  constructor(
    private appInfoService: AppInfoService,
    private router: Router,
    private quoteToolsService: QuoteToolsService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private deviceDetector: DeviceDetectorService
  ) { }

  ngOnInit() {
    this.isOnline = this.appInfoService.state.isOnline;
    this.isMobile = this.deviceDetector.isMobile();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  goToQuotes() {
    this.router.navigate(['quotes']);
  }

  printOrder() {
    const payload = {
      id: this.quoteRevisionId
    };
    this.quoteToolsService.printQuote(payload);
  }

  exportOrder() {
    const payload = {
      quoteNumber: this.orderConfirmationNumber,
      id: this.quoteRevisionId
    };
    this.quoteToolsService.exportQuote(payload, false, true);
  }

  emailOrder() {
    const dialogRef = this.dialog.open(PrintExportQuoteComponent, {
      data: { isEmailOnly: true, isOrder: true, ensEmails: this.ensEmails, contacts: this.contacts }
    });

    this.subs.add(dialogRef.afterClosed().subscribe(result => {
      if (result?.emailAddresses?.length) {
        this.quoteToolsService.emailQuote(this.quoteRevisionId, result.emailAddresses)
          .subscribe((response: BaseResponse) =>
            this.notificationService.showNotification(response.actionMessage, NotificationType.Success));
      }
    }));
  }
}
